import React from 'react';

import {
  useTimer,
  useTimerEvents,
  useTimers
} from '../../hooks/use-game-timer';
import { GameDocumentContext } from '../../contexts/game-document';
import { GetTaskContentById } from '../../utils/game-document/assets/task-contents';

export const TimerProgressForm: React.FC<{
  formIndex: number;
  taskContentId: string;
  onSubmitHandler: () => Promise<void>;
}> = ({ formIndex, taskContentId, onSubmitHandler }) => {
  const [gameDocument] = React.useContext(GameDocumentContext);

  const { start } = useTimers();

  const selectedTaskContent = React.useMemo(() => {
    return GetTaskContentById(gameDocument.gameDocument!, taskContentId);
  }, [taskContentId, gameDocument.gameDocument]);

  const forms = selectedTaskContent?.forms ?? [];
  const currentForm = forms.length > 0 ? forms[formIndex] : undefined;
  const isTimerQuestion =
    currentForm !== undefined
      ? currentForm.scoringReduction !== undefined
      : false;

  useTimerEvents(currentForm?.id ?? '', {
    onElapsed: () => {
      onSubmitHandler();
    }
  });

  React.useEffect(() => {
    if (!currentForm || !isTimerQuestion) return;

    start(currentForm.id);
  }, [currentForm, isTimerQuestion]);

  if (!isTimerQuestion) return;

  return <></>;
};
